<template>
  <div class="the-layout">
    <mobile-layout v-if="$store.getters.isMobile">
      <slot></slot>
    </mobile-layout>
    <desktop-layout v-else>
      <slot></slot>
    </desktop-layout>
  </div>
</template>
<script>
import DesktopLayout from "./DesktopLayout.vue";
import MobileLayout from "./MobileLayout.vue";
export default {
  components: {
    DesktopLayout,
    MobileLayout,
  },
  created() {
    this.$store.dispatch("detectMobile");
  },
};
</script>
